/**
 * Generate AWS API fetch config
 * @param apiKey 
 * @returns 
 */
export const awsAPIConfigFactory = (apiKey: string) => {
    return (method: 'POST' | 'GET' | 'PUT' | 'DELETE', token?: string, body?: any): RequestInit => {
        return {
            method,
            body: body ? JSON.stringify(body) : undefined,
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'x-api-key': apiKey,
            }
        };
    }
}